import AIAgentTemplate from './AIAgentTemplate';

// Compact wrapper for an FAQ-focused ElevenLabs agent using the reusable template.
// Configure via environment variables or hard-coded fallback.
const FAQAIAgentAll = () => {
  const agentId = import.meta.env.VITE_ELEVENLABS_FAQ_AI_AGENT_ID;
  const title = 'FAQ Agent';
  const subtitle = 'FAQs & Knowledge';
  const suggestionCommands = [
    { label: 'General FAQs', command: 'start FAQ' }
  ];

  return (
    <AIAgentTemplate
      agentId={agentId}
      title={title}
      subtitle={subtitle}
      suggestionCommands={suggestionCommands}
      logoSrc="./logo-bw.png"
      logoAlt="Start"
      textOnly={false}
    />
  );
};

export default FAQAIAgentAll;
